/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React from 'react';

// styles and images
import styles from './Header.module.css';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
function Header() {
  return (
    <header>
      <h1 className={styles.mainHeading}> HSB
      </h1>
    </header>
  );
}

export default Header;
